import BackupSettingsError from './Error';

export default BackupSettingsError;
